<template>
  <article class="submit-art">
    <section class="register-submit-wrap">
      <group>
        <!-- 登记类型 -->
        <cell primary="content">
          <div slot="icon" class="weui_label">登记类型</div>
          <radio class="register-radio" :options="registerOptions" v-model="registerType" @on-change="registerTypeChange"></radio>
        </cell>
        <cell key="judge-plate" class="plate-cell" is-link v-if="registerType === '1'">
          <div slot="icon" class="weui_label">车牌号</div>
          <x-input
            slot="after-title"
            class="search-box"
            :max="7"
            :show-clear="false"
            @on-focus="handleFocus"
            :placeholder="'请输入车牌号'"
            :is-type="val_plate_number"
            v-model="carRegister.plate_number">
            <div slot="label" class="label" @click="selectPlate">
              <span>{{ carRegister.plate }}</span>
              <i class="icon"></i>
            </div>
          </x-input>
        </cell>
        <!-- 选择品牌 -->
        <cell @click.native="getBrand" :bdStart="true" is-link v-if="registerType === '1'">
          <div slot="icon" class="weui_label">品牌</div>
          <p slot="after-title" v-if="carRegister.brand_id">{{carRegister.brand}}</p>
          <p slot="after-title" style="color: #a0a0a0;" v-else>请选择车辆品牌</p>
        </cell>
        <!-- 登记类型为进车间时，需要选择进店车辆 -->
        <cell @click.native="getCar" :bdStart="true" is-link v-if="registerType === '2'">
          <div slot="icon" class="weui_label">进店车辆</div>
          <p slot="after-title" v-if="carRegister.workshop_plate_number">{{carRegister.workshop_plate_number}}</p>
          <p slot="after-title" style="color: #a0a0a0;" v-else>请选择进店车辆</p>
        </cell>
        <!-- 选择进店时间 -->
        <datetime
          title="进店时间"
          v-if="registerType === '1'"
          v-model="carRegister.visit_time"
          placeholder="请选择进店时间"
          :min-year="1970"
          start-date="1970-01-01"
          :end-date="endDate"
          format="YYYY-MM-DD HH:mm"
          confirm-text="完成"
          cancel-text="取消"
          class="datetime"
          :min-hour="startHour"
          :max-hour="endHour"
          @input="onEnterShopTimeInput"
        >
          <!-- :max-minute="endMinute" -->
        </datetime>
        <!-- 选择进车间时间 -->
        <datetime
          v-if="carWorkshops.length > 0"
          title="进车间时间"
          v-model="carRegister.visit_workshop_time"
          :placeholder="registerType === '1' ? '请选择进车间时间（非必填）' : '请选择进车间时间'"
          :end-date="endDate"
          :min-year="1970"
          start-date="1970-01-01"
          format="YYYY-MM-DD HH:mm"
          confirm-text="完成"
          cancel-text="取消"
          class="datetime"
          :min-hour="startHour"
          :max-hour="endHour"
          @input="onEnterWorkshopTimeInput"
        >
          <!-- :max-minute="endMinute" -->
        </datetime>
        <selector
          v-if="carRegister.visit_workshop_time"
          title="进入车间名称"
          placeholder="请选择进入车间名称"
          :options="carWorkshops"
          v-model="carRegister.workshop_id"
        >
        </selector>
      </group>
      <section class="btn-bottom">
        <div class="btn-fix">
          <a class="btn" @click.stop="onSubmit" v-if="registerType === '1'">确认登记</a>
          <a class="btn" @click.stop="onWorkShopSubmit" v-else>确认登记</a>
        </div>
      </section>
      <keyboard v-model="showProvinces" @handle-value="handleValue">
      </keyboard>
      <keyboard v-model="showAlphanumeric" @handle-value="handleAlphanumericValue" @handle-delete="handleDelete" :type="'alphanumeric'">
      </keyboard>
    </section>
  </article>
</template>
<script>
import {
  Group,
  Cell,
  Radio,
  XInput,
  Selector,
  Datetime,
  Keyboard
} from '@lx-frontend/cvux'
import util from '../../common/util'

export default {
  components: {
    Group,
    Cell,
    Radio,
    XInput,
    Selector,
    Datetime,
    Keyboard
  },
  data() {
    return {
      endDate: util.formatTime(new Date(), 'yyyy-MM-dd'),
      startHour: 5,
      endHour: 22,
      // endMinute: 22,
      registerOptions: [{
        key: '1',
        value: '进店'
      }, {
        key: '2',
        value: '进车间'
      }],
      registerType: '1', // 登记类型
      carRegister: {
        workshop_id: '', // 车间名称（通道）
        plate: '', // 当前省份
        brand_id: '', // 车辆品牌ID
        brand: '', // 车辆品牌名称
        visit_time: '', // 进店时间
        visit_workshop_time: '', // 进车间时间
        workshop_plate_number: '', // 进店车辆车牌号 ---- 登记类型为进车间
        plate_number: '' // 当前车牌号的关键字
      },
      carWorkshops: [],
      isClicked: false,
      showProvinces: false, // 控制省份键盘显示
      showAlphanumeric: false // 控制字母键盘显示
    }
  },
  watch: {
    registerType () {
      this.carRegister.visit_workshop_time = ''
      this.carRegister.workshop_id = ''
    }
  },
  async created() {
    this.registerType = this.$route.query.type || '1'
    // 初始化车牌省份
    await this.handleInitPlate()

    this.carRegister = Object.assign({}, this.$store.state.carRegister.carInfo)
    // 获取该店的车辆通道（车间名称）
    this.$rest.carRegister.getWorkshops(null).then(res => {
      if (res.code === 0) {
        let arr = []
        if (res.data) {
          res.data.forEach(workshop => {
            arr.push({
              key: workshop.workshop_id,
              value: workshop.workshop_name || workshop.workshop_id
            })
          })
        }
        this.carWorkshops = arr
      } else {
        this.showToast(res.message)
      }
    })
  },
  methods: {
    registerTypeChange (type) {
      if (type === '1') {
        this.carRegister.workshop_plate_number = ''
        this.carRegister.visit_time = ''
        this.$store.dispatch('UPDATE_CAR_REGISTER_INFO', Object.assign({}, this.carRegister))
      }
    },
    async handleInitPlate() {
      const from = this.$route.query.from
      if (from && from === '/car/brand') return

      const {
        code,
        data
      } = await this.$rest.store.getStoreInfo()

      if (code === 0) {
        const plateArr = data.plate_prefix_code ? data.plate_prefix_code.split('') : ['粤']
        const plateObj = {
          plate: plateArr[0],
          plate_number: plateArr[1] || ''
        }
        this.$store.dispatch('UPDATE_CAR_REGISTER_INFO', {
          ...this.$store.state.carRegister.carInfo,
          ...plateObj
        })
      }
    },
    getBrand() {
      this.$store.dispatch('UPDATE_CAR_REGISTER_INFO', Object.assign({}, this.carRegister))
      this.$router.push({
        path: '/car/brand',
        query: {
          from: '/carRegister/index'
        }
      })
    },
    getCar () {
      this.$store.dispatch('UPDATE_CAR_REGISTER_INFO', Object.assign({}, this.carRegister))
      this.$router.push({
        path: '/carRegister/car',
        query: {
          from: '/carRegister/index'
        }
      })
    },
    val_brand_id(val) {
      return this.validate(val, '请选择您的车型')
    },
    val_plate_number(val) {
      // 对车牌第一个字母可选。最后一次检查的时候用到
      // 增加小写字母判断，历史数据可能有小写
      let plateReg = /^[\u4e00-\u9fa5]?[A-Z]{1}[A-Z0-9]{4,5}[A-Z0-9\u4e00-\u9fa5]{1}$/i
      let valid = plateReg.test(val)
      return this.validate(valid, "请选择车牌号，如'粤B12345'")
    },
    val_workshop_plate_number(val) {
      // 对车牌第一个字母可选。最后一次检查的时候用到
      // 增加小写字母判断，历史数据可能有小写
      let plateReg = /^[\u4e00-\u9fa5]?[A-Z]{1}[A-Z0-9]{4,5}[A-Z0-9\u4e00-\u9fa5]{1}$/i
      let valid = plateReg.test(val)
      return this.validate(valid, "请选择车牌号，如'粤B12345'")
    },
    val_visit_time(val) {
      let iosTime = val.replace(/-/g, '/')
      if (new Date(iosTime).getTime() > new Date().getTime()) {
        return this.validate(false, '进店时间不能大于当前时间')
      }
      return this.validate(val, '请选择进店时间')
    },
    val_visit_workshop_time(val) {
      let iosTime = val.replace(/-/g, '/')
      if (new Date(iosTime).getTime() > new Date().getTime()) {
        return this.validate(false, '进车间时间不能大于当前时间')
      }
      return this.validate(true)
    },
    validate(val, msg) {
      let info = {}
      if (val) {
        info.valid = true
        info.msg = ''
      } else {
        info.valid = false
        info.msg = msg
      }
      return info
    },
    getError() {
      let fields = [
        'plate_number',
        'brand_id',
        'visit_time',
        'visit_workshop_time'
      ]
      for (let i = 0; i < fields.length; i++) {
        let v = fields[i]
        let val = this.carRegister[v]
        let item = this['val_' + v](val)
        if (!item.valid) {
          return item
        }
      }
    },
    getWorkShopError() {
      let fields = [
        'workshop_plate_number',
        'visit_workshop_time'
      ]
      for (let i = 0; i < fields.length; i++) {
        let v = fields[i]
        let val = this.carRegister[v]
        let item = this['val_' + v](val)
        if (!item.valid) {
          return item
        }
      }
    },
    onSubmit() {
      if (this.isClicked) {
        return false
      }
      let error = this.getError()
      if (!error) {
        this.isClicked = true // 防止请求一次后，多次请求
        let params = this.carRegister
        params = Object.assign({}, params, {
          visit_time: params.visit_time + ':00',
          visit_workshop_time: params.visit_workshop_time && params.visit_workshop_time + ':00',
          plate_number: params.plate + params.plate_number
        })
        delete params.brand_id
        delete params.plate
        this.$rest.carRegister.postRegister(params).then(res => {
          this.isClicked = false
          this.$store.dispatch('UPDATE_CAR_REGISTER_INFO', {
            plate: '粤', // 当前省份
            brand_id: '', // 车辆品牌ID
            workshop_id: '',
            brand: '', // 车辆品牌名称
            visit_time: '', // 进店时间
            visit_workshop_time: '', // 进车间时间
            workshop_plate_number: '',
            plate_number: '' // 当前车牌号的关键字
          })
          if (res.code === 0) {
            this.$router.push({
              path: `/carregister/success`,
              query: {
                exist: 1
              }
            })
          } else if (res.code === 450) {
            // 当前车辆已经进店
            this.$router.push({
              path: `/carregister/success`,
              query: {
                exist: 0,
                plate_number: params.plate_number
              }
            })
          } else {
            this.showToast(res.message)
          }
        })
      } else {
        // 表单验证失败
        if (error.msg) {
          this.showToast(error.msg)
        }
      }
    },
    onWorkShopSubmit () {
      if (this.isClicked) {
        return false
      }
      let error = this.getWorkShopError()
      if (!error) {
        this.isClicked = true // 防止请求一次后，多次请求
        let params = {
          visit_workshop_time: this.carRegister.visit_workshop_time && this.carRegister.visit_workshop_time + ':00',
          plate_number: this.carRegister.workshop_plate_number,
          workshop_id: this.carRegister.workshop_id
        }
        this.$rest.carRegister.postWorkShopRegister(params).then(res => {
          this.isClicked = false
          this.$store.dispatch('UPDATE_CAR_REGISTER_INFO', {
            plate: '粤', // 当前省份
            brand_id: '', // 车辆品牌ID
            brand: '', // 车辆品牌名称
            workshop_id: '',
            visit_time: '', // 进店时间
            visit_workshop_time: '', // 进车间时间
            workshop_plate_number: '',
            plate_number: '' // 当前车牌号的关键字
          })
          if (res.code === 0) {
            this.$router.push({
              path: `/carregister/success`,
              query: {
                exist: 1
              }
            })
          } else if (res.code === 450) {
            // 当前车辆已经进店
            this.$router.push({
              path: `/carregister/success`,
              query: {
                exist: 0,
                plate_number: params.plate_number
              }
            })
          } else {
            this.showToast(res.message)
          }
        })
      } else {
        // 表单验证失败
        if (error.msg) {
          this.showToast(error.msg)
        }
      }
    },
    onEnterShopTimeInput(val) {
      const value = new Date(val).getTime()
      const now = new Date()
      if (value > now) {
        this.showToast('当前时间有误，请重新选择!')
        this.$nextTick(() => {
          this.carRegister = { ...this.carRegister, visit_time: '' }
        })
      }
    },
    onEnterWorkshopTimeInput(val) {
      const value = new Date(val).getTime()
      const now = new Date()
      if (value > now) {
        this.showToast('当前时间有误，请重新选择!')
        this.$nextTick(() => {
          this.carRegister = { ...this.carRegister, visit_workshop_time: '' }
        })
      }
    },
    /**
     * @description 处理省份键盘的值
     * @param value
     */
    handleValue(value) {
      this.carRegister.plate = value
      this.handleFocus()
    },
    /**
     * @description 处理字母数字键盘的值
     * @param value
     */
    handleAlphanumericValue(value) {
      if (this.carRegister.plate_number.length < 7) {
        this.carRegister.plate_number += value
      }
    },
    /**
     * @description 字母数字键盘删除处理
     * @param value
     */
    handleDelete(value) {
      this.carRegister.plate_number = this.carRegister.plate_number.substring(0, this.carRegister.plate_number.length - 1)
    },
    /**
     * @description 处理点击省份按钮，弹起省份键盘
     */
    selectPlate() {
      this.showAlphanumeric = false
      this.showProvinces = true
    },
    /**
     * @description 处理获取表单焦点，阻止手机默认键盘弹起
     */
    handleFocus() {
      document.activeElement.blur()
      this.showAlphanumeric = true
    }
  }
}
</script>
<style lang="less">
@w2: 75rem;
.submit-art {
  position: relative;
  .datetime .vux-datetime-value,
  .vux-popup-picker-value {
    color: #000;
  }
  .register-submit-wrap {
    .weui_label, .datetime .weui_cell_bd p {
      width: 2.6rem;
    }
  }
}

.register-radio {
  display: flex;
  .weui_cell_radio {
    padding: 0;
    margin-right: 80/@w2;
    flex-direction: row-reverse;
    &::before {
      height: 0;
      border-top: 0;
    }
    // .weui_cell_primary {
    //   display: inline-block;
    // }
    // .weui_cell_ft {
    //   display: inline-block;
    // }
    .weui_icon_checked {
      display: block;
      width: 32/@w2;
      height: 32/@w2;
      border: 2/@w2 solid #e7e7e9;
      border-radius: 50%;
      box-sizing: border-box;
    }
  }
  .weui_cell_ft {
    padding-left: 0;
    margin-right: 20/@w2;
    align-self: center;
  }
  .weui_check:checked + .weui_icon_checked {
    position: relative;
    border: 2/@w2 solid #509eff;
  }
  .weui_check:checked + .weui_icon_checked:before {
    display: block;
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 20/@w2;
    height: 20/@w2;
    margin: auto;
    border-radius: 50%;
    background-color: #509eff;
  }
}

.plate-cell {
  .search-box {
    padding: 0 !important;
  }
}

.search-box {
  height: 60 / @w2;
  // padding: 15/@w2 40/@w2 15/@w2 10/@w2;

  .label {
    display: flex;
    align-items: center;
    padding: 13 / @w2 18 / @w2;
    margin-right: 20 / @w2;
    line-height: 60 / @w2;
    background-color: #eeeeee;
    border-radius: 4 / @w2;
    float: right;
    span {
      display: inline-block;
      font-size: 15px;
      line-height: 15 / @w2;
    }
  }
  .icon {
    display: inline-block;
    margin: 6px 0 0 3px;
    width: 0px;
    height: 0px;
    border: 12 / @w2 solid #5d5c57;
    border-top-color: #5d5c57;
    border-bottom-color: transparent;
    border-left-color: transparent;
    border-right-color: transparent;
  }
}

</style>
